export default {
  titulo: 'Dúvidas mais comuns',
  subtitulo: {
    parte1: 'Separamos a dúvidas mais comuns por tópicos. Caso sua dúvida não seja esclarecida,',
    parte2: ' fale conosco.',
  },
};
